import ActionButton from 'components/action-button';
import Dialog from 'components/dialog';
import { LoyaltyPromotionType } from 'generated/graphql-gateway';
import { t } from 'state/intl/translations';
import { TranslationKey } from 'state/intl/types';

export const LoyaltyIncentiveSwapDialog = ({
  isOpen,
  onClose,
  onSwap,
  incentiveType,
}: {
  isOpen: boolean;
  incentiveType: LoyaltyPromotionType;
  onClose: () => void;
  onSwap: () => void;
}) => {
  const isReward = incentiveType === LoyaltyPromotionType.REWARD;
  const heading = isReward
    ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
      t('oneRewardPerOrder' as any, 'One Reward Per Order')
    : t('oneOfferPerOrder' as any, 'One Offer Per Order');
  const body = isReward
    ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
      t('swapRewardText' as any, `You've already added an reward. Would you like to swap?`)
    : t('swapOfferText' as any, `Would you like to replace the offer already in your cart?`);

  return (
    <Dialog
      showDialog={isOpen}
      heading={heading}
      body={body}
      showCloseButton
      onDismiss={onClose}
      closeButtonLabelId={'keepCurrent' as TranslationKey}
      closeButtonDefaultMessage="Keep Current"
      actions={
        <ActionButton onPress={onSwap} fullWidth={true} testID="dialog-confirm-btn">
          {isReward ? t('swapReward' as TranslationKey, 'Swap Reward') : t('replace', 'Replace')}
        </ActionButton>
      }
      modalAppearanceEventMessage={''}
    />
  );
};
